import { render } from "./Elementi.vue?vue&type=template&id=2119c62a"
import script from "./Elementi.vue?vue&type=script&lang=js"
export * from "./Elementi.vue?vue&type=script&lang=js"

import "./Elementi.vue?vue&type=style&index=0&id=2119c62a&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\es.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__